import React from 'react'
import { useHistory } from 'react-router-dom'

import { StyledWrapper, StyledButton } from './style'

const ToggleLinks = ({ linkLeft, linkRight, selectedLink }) => {
  const history = useHistory()
  return (
    <StyledWrapper>
      <StyledButton
        variant="outlined"
        selected={selectedLink === linkLeft.text.toLowerCase()}
        onClick={() => history.push(linkLeft.url)}
      >
        {linkLeft.text}
      </StyledButton>
      <StyledButton
        variant="outlined"
        selected={selectedLink === linkRight.text.toLowerCase()}
        onClick={() => history.push(linkRight.url)}
      >
        {linkRight.text}
      </StyledButton>
    </StyledWrapper>
  )
}

export default ToggleLinks
